import PropTypes from "prop-types";
import useUmamiScript from "./useUmamiScript";

var UmamiAnalytics = function UmamiAnalytics(_ref) {
  var source = _ref.source,
      websiteId = _ref.websiteId;
  useUmamiScript(source, websiteId);
  return "";
};

UmamiAnalytics.propTypes = {
  source: PropTypes.string.isRequired,
  websiteId: PropTypes.string.isRequired
};
export default UmamiAnalytics;